export default __webpack_public_path__ + "static/media/gif.4a95ac50.gif";